import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

let activeFacilityId = null;
export const setActiveFacility = (id) => { activeFacilityId = id; };

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const fid = activeFacilityId || (typeof localStorage !== "undefined" && localStorage.getItem("span_active_facility"));
  if (fid) config.headers["X-Facility-Id"] = fid;
  return config;
});

// Silent access-token refresh on 401. A single /auth/refresh is in flight at a time;
// concurrent 401s queue behind it and retry once the refresh resolves.
// Portal (/portal/*) has its own independent patient session — the staff refresh/redirect
// must never act on it, otherwise a portal 401 would bounce the patient to the staff /login.
const NO_REFRESH = ["/auth/login", "/auth/refresh", "/auth/logout", "/portal/"];
let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error;
    if (!response || response.status !== 401 || !config || config._retried) throw error;
    if (NO_REFRESH.some((p) => (config.url || "").startsWith(p))) throw error;

    config._retried = true;
    try {
      if (!refreshing) {
        refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
      }
      await refreshing;
      return api(config);
    } catch (e) {
      const path = typeof window !== "undefined" ? window.location.pathname : "";
      // Never bounce a patient on the portal to the staff /login — the portal has its own session.
      if (path && !path.startsWith("/login") && !path.startsWith("/portal") && !path.startsWith("/health")) {
        window.location.href = "/login";
      }
      throw error;
    }
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
